import { http } from "@common";
import endpoint from "../endpoint_cis";

export default {
    // getMyProfile: () => {
    //     if (window._localFakeUser) {
    //         return Promise.resolve(window._localFakeUser);
    //     }

    //     return http.get(endpoint.user.myprofile_get);
    // },
    login: () => {
        return http.get(endpoint.account.login);
    },
    getHostName: () => {
        return http.get(endpoint.account.get_host_name);
    },
    checkPassword: (params) => {
        return http.post(endpoint.account.check_password_post, params);
    },
    changePassword: (params) => {
        return http.post(endpoint.account.change_password_post, params);
    },
    getVerificationPhoto: (params) => {
        return http.post(endpoint.account.verification_photo_post, params);
    },
    checkVerificationCode: (params) => {
        return http.post(endpoint.account.check_verification_code_post, params);
    },
    checkEmailOtpCode: (params) => {
        return http.post(endpoint.account.check_email_otp, params);
    },
    checkVerificationBefore: (params) => {
        return http.post(endpoint.account.check_verification_before_post, params);
    },
    checkCaptchaVerification: (params) => {
        return http.post(endpoint.account.check_captcha_post, params);
    },
    checkCaptchaAndStudentId: (params) => {
        return http.get(endpoint.account.check_captcha_studentid_post, params);
    },
    getVerificationVoice: (photoId) => {
        return http.post(endpoint.account.verification_voice_post.format(photoId));
    }
};